'use client';

import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import useWalletIsConnected from 'src/hooks/useWalletIsConnected';
import InlineLoadingBar from './InlineLoadingBar/InlineLoadingBar';
import SecondaryConnectWalletButton from './SecondaryConnectWalletButton';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { PageRoute } from 'src/constants/constants';
import ConnectToTradeButton from 'src/components/ConnectToTradeButton';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';
import { cm } from 'src/utils/classNames';

interface ContentGuardProps extends WithChildren, WithClassName {
	requireWallet?: boolean;
	requireAccount?: boolean;
	isLoading?: boolean;
}

function ContentGuard({
	children,
	requireWallet,
	requireAccount,
	isLoading,
	className,
}: ContentGuardProps) {
	const connected = useWalletIsConnected();
	const currentAccountExists = useDriftAccountStore(
		(s) => !!s.getCurrentUserAccount()
	);
	const currentRoute = useDriftStore((s) => s.currentPageRoute);
	const isTradePage = currentRoute === PageRoute.trade;

	if (requireWallet && !connected) {
		return (
			<FallbackWrapper className={className}>
				{isTradePage ? (
					<ConnectToTradeButton />
				) : (
					<SecondaryConnectWalletButton />
				)}
			</FallbackWrapper>
		);
	}

	if (requireAccount && connected && !currentAccountExists) {
		return (
			<FallbackWrapper className={className}>
				<span className="typo-body-sm text-text-tertiary">
					No account found
				</span>
			</FallbackWrapper>
		);
	}

	if (isLoading) {
		return (
			<FallbackWrapper className={className}>
				<InlineLoadingBar />
			</FallbackWrapper>
		);
	}

	return <>{children}</>;
}

function FallbackWrapper({ children, className }: WithChildren<WithClassName>) {
	return (
		<div
			className={cm(
				'flex size-full flex-col items-center justify-center',
				'min-h-40 sm:min-h-80',
				className
			)}
		>
			{children}
		</div>
	);
}

export default ContentGuard;
